import { Languages } from "../enums/languages";

export const supportedLanguages = [
    Languages.en,
    Languages.he,
]